// 全局搜索
import { PAGE_LEVEL } from '@/constants';
export default {
  meta: { localeModules: ['globalSearch', 'aiChat', 'aiAssistant', 'report', 'roadshow'] },
  // 全局搜索
  path: '/globalSearch',
  redirect: '/globalSearch/index',
  children: [
    {
      path: 'index',
      name: 'globalSearchIndex',
      component: () => import(/* webpackChunkName: 'global-search' */ '@/pages/globalSearch/index'),
      meta: {
        name: 'routers.global_search_global_search',
        pageLevel: PAGE_LEVEL.FIRST,
        componentName: 'GlobalSearchIndex',
        keepAlive: true,
        electronSingle: false
      }
    }
  ]
};
